/**
 * @param {function} callFunc 
 * @returns {{ success: boolean, error: any | null, data: any | null }}
 */
export const fetchDataOrError = async (callFunc) => {
  try {
    const data = await callFunc();
    return { success: true, data, error: null };
  } catch (error) {
    console.error(error);
    return { success: false, data: null, error };
  }
}